import { css } from "@emotion/react";
import fonts from "./fonts";

export const a11y = css`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  border: 0;
  clip: rect(0, 0, 0, 0);
`;

export const inheritFont = css`
  color: inherit;
  letter-spacing: inherit;
  font-family: inherit;
`;

export const resetAppearance = css`
  appearance: none;
  background: none;
  box-shadow: none;
  border: 0;
`;

export const resetSpacing = css`
  margin: 0;
  padding: 0;
`;

export const reset = (theme) => css`
  ${fonts};
  body {
    ${css([resetSpacing])};
  }
  hr {
    ${css([resetSpacing])};
  }
  p {
    ${css([resetSpacing])};
  }
  button {
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    ${css([inheritFont, resetAppearance, resetSpacing])};
    * {
      position: relative;
      top: 0;
      left: 0;
    }
  }
  input {
    ${inheritFont};
    ${resetAppearance};
    ${resetSpacing};
    &::-ms-clear {
      display: none;
    }
    &::-webkit-search-cancel-button {
      display: none;
    }
    &:focus {
      outline: none;
    }
  }
  ul {
    list-style-type: none;
    font-size: 0px;
    ${css([resetSpacing])};
  }
  li {
    font-size: ${theme.desktop.fontSize};
    line-height: initial;
  }

  a {
    text-decoration: none;
    color: #111;
  }

  * {
    .a11y {
      ${css([a11y])};
    }
    margin: 0;
    padding: 0;
    font-size: ${theme.desktop.fontSize};
    box-sizing: border-box;
  }

  pre {
    font-family: inherit;
  }
`;

export const typography = (theme) => css`
  body,
  table,
  table td,
  input,
  select,
  textarea {
    font-family: ${theme.fontFamily.default};
    color: ${theme.color.font};
  }

  h1 {
    font-size: ${theme.desktop.h1};
  }

  h2 {
    font-size: ${theme.desktop.h2};
  }

  h3 {
    font-size: ${theme.desktop.h3};
  }

  h4 {
    font-size: ${theme.desktop.h4};
  }

  h5 {
    font-size: ${theme.desktop.h5};
  }

  h6 {
    font-size: ${theme.desktop.h6};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 700;
    margin-bottom: 0px;
  }
`;
